import * as Cmp from "@impero-com/common/utils/comparison";
import { leftPad } from "@impero-com/common/utils/formatting";

import { PeriodDate } from "components/dateFilter/types";

const comparePeriodDates: Cmp.ComparisonFunction<PeriodDate> = Cmp.chain([
    Cmp.map((pd) => pd.year),
    Cmp.map((pd) => pd.month),
    Cmp.map((pd) => pd.day),
]);

function formatPeriodDate(periodDate: PeriodDate) {
    return (
        periodDate.year +
        "-" +
        leftPad(periodDate.month, 2, "0") +
        "-" +
        leftPad(periodDate.day, 2, "0")
    );
}

export { comparePeriodDates, formatPeriodDate };
